import { render } from "./DeleteAlert.vue?vue&type=template&id=46e88ecc"
import script from "./DeleteAlert.vue?vue&type=script&lang=js"
export * from "./DeleteAlert.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__